import React from "react";
import "./Button.css";

const buttonSizes = {
  small: {
    fontSize: "12px",
    padding: "8px 16px",
    borderRadius: "13px",
  },
  medium: {
    fontSize: "18px",
    padding: "15px 30px",
    borderRadius: "21px",
  },
  large: {
    fontSize: "24px",
    padding: "18px 35px",
    borderRadius: "26px",
  },
};

export const Button = ({
  text,
  onClick,
  type = "primary",
  size = "medium",
  icon = null,
}) => {
  const handleTouchEnd = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <button
      onClick={onClick}
      style={buttonSizes[size]}
      className={`button ${type}`}
      onTouchEnd={handleTouchEnd}
    >
      {icon}
      {text}
    </button>
  );
};
